import React,{useState,useEffect} from "react"
import {Modal,ModalHeader,ModalFooter,ModalBody} from   "reactstrap"
import Api from "./Api";
import { useGlobal } from "./Reducer";
import _ from "lodash" 
import Toggle from 'react-toggle'
import "react-toggle/style.css" 
import ArticleEditor from "./ArticleEditor";

const ARTICLE_1="article_1";
const ARTICLE_2="article_2";
const ARTICLE_3="article_3";
export {ARTICLE_1,ARTICLE_2,ARTICLE_3}
export default (props)=>{

    const [articles,setArticles]=useState([]);
    const [gs,ga]=useGlobal();
    const [showEditor,setShowEditor]=useState(false);
    const [idToEdit,setIdToEdit]=useState(null);
    const [selectedArticleId,setSelectedArticleId]=useState(gs.appData[props.articleIndex]||0);




    const doDelete=(article)=>{
        
                    ga.showBooleanAlert("Sure?",`Are you sure you want to delete the article with title "${article.title}"`,()=>{
                        ga.loading(true);
                        Api.deleteArticle(article.id).then(()=>{
                                    getData();
                                }).catch(err=>{}).finally(()=>{
                                    ga.loading(false);
                                })
                    })
    }


    const getData=()=>{
        ga.loading(true);
        Api.getAllArticles().then(articles=>{
            setArticles(articles);
        }).catch(err=>{
            alert(err);
        }).finally(()=>{
            ga.loading(false);
        })
    }

    useEffect(()=>{
      
        getData()
    },[])



    return (<Modal size="xl" isOpen={true}>
        {showEditor && <ArticleEditor 
            article={idToEdit}
        onClose={()=>{
            getData();
            setShowEditor(false);
        }} />}
                <ModalHeader>Select Article</ModalHeader>
                <ModalBody>
                    <div style={{maxHeight:400,overflow:"auto"}}>
                           <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            Image
                                        </th>
                                        <th>
                                            Title
                                        </th>
                                        <th>
                                            Intro
                                        </th>
                                        <th>
                                            Select
                                        </th>
                                        <th>
                                            Edit
                                        </th>
                                        <th>
                                            Delete
                                        </th>

                                    </tr>
                                </thead>
                        <tbody>
                            {
                                _.map(articles,(article,index)=>{
                                            return (
                                                <tr key={"key"+index}>
                                                <td>
                                                    <img src={article.image} style={{maxHeight:100,maxWidth:100}} />
                                                </td>
                                                <td>
                                                    {article.title}
                                                </td>
                                                <td>
                                                {article.intro}
                                                </td>
                                                <td>
                                                    <Toggle checked={article.id==selectedArticleId}
                                                        onChange={(e)=>{
                                                            if(e.target.checked)
                                                                {
                                                                    setSelectedArticleId(article.id);
                                                                    gs.appData[props.articleIndex]=article.id;
                                                                    Api.setArticleIndex(article.id,props.articleIndex,gs.appData.id);
                                                                }

                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    
                                                    <button
                                                        onClick={()=>{
                                                            setIdToEdit(article);
                                                            setShowEditor(true);
                                                        }}
                                                    
                                                    className="btn btn-sm btn-info">Edit</button>
                                                </td>
                                                <td>
                                                <button  onClick={()=>{
                                                           doDelete(article);
                                                        }} className="btn btn-sm btn-danger">Delete</button>
                                                </td>
        
                                            </tr>
                                            );
                                })
                           }
                           </tbody>
                           </table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-success" onClick={()=>{
                            setIdToEdit(null);
                        setShowEditor(true)}}>Add New</button>
                    <button className="btn btn-secondary" onClick={()=>props.onClose()}>Close</button>
                </ModalFooter>
    </Modal>);  

}